import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { roomQueryKeys } from './queryKeys';

export const getRoom = async (roomId) => {
  if (roomId) {
    return await request.get(
      `/RentPlace/rental_house/office/${roomId}`,
      {},
      'При загрузке помещения произошла ошибка'
    );
  }
};

const useRoom = (roomId) =>
  useQuery(roomQueryKeys(roomId), () => getRoom(roomId), {
    placeholderData: {},
    enabled: !!roomId,
  });
export default useRoom;
